const counters: Record<string, number> = {};
let isTestMode = false;

export function setUniqueIdTestMode(enabled: boolean) {
  isTestMode = enabled;
  resetUniqueIdCounters();
}

export function resetUniqueIdCounters() {
  for (const key in counters) {
    delete counters[key];
  }
}

export function uniqueID(prefixOrLength: number | string = 9): string {
  if (isTestMode) {
    const prefix = typeof prefixOrLength === 'string' ? prefixOrLength : 'uid';

    if (counters[prefix] === undefined) {
      counters[prefix] = 0;
    }

    const id = counters[prefix].toString().padStart(5, '0');
    counters[prefix]++;

    return typeof prefixOrLength === 'string' ? `${prefix}_${id}` : id;
  }

  if (typeof prefixOrLength === 'string') {
    const randomPart = Math.random().toString(36).substr(2, 9);
    return `${prefixOrLength}_${randomPart}`;
  }

  return Math.random()
    .toString(36)
    .substr(2, prefixOrLength);
}
